function fixObjectFit () {
  const isIE = !!window.MSInputMethodContext && !!document.documentMode
  if (isIE) {
    const images = []

    const objectFitModules = [
      '.a-stage',
      '.a-quote-slider',
      '.a-teaser-slider-two-column',
      '.a-portfolio-slider',
      '.g-teaser-job',
      '.g-teaser-portfolio',
      '.a-portfolio-grid',
      '.s-404-stage'
    ]

    objectFitModules.forEach((module) => {
      const moduleDOM = document.querySelector(module)

      if (moduleDOM) {
        const moduleImages = moduleDOM.querySelectorAll('img')
        if (moduleImages && moduleImages.length > 0) {
          moduleImages.forEach((moduleImage) => {
            images.push(moduleImage)
          })
        }
      }
    })

    console.log(images)
    images.forEach((img) => {
      let imgUrl

      // Check via image is integrated with dataset or src
      if (img && img.dataset && img.dataset.src) {
        imgUrl = img.dataset.src
      } else if (img && img.src) {
        imgUrl = img.src
      }

      if (img && imgUrl) {
        img.parentElement.style.backgroundImage = 'url(' + imgUrl + ')'
        img.parentElement.classList.add('compat-object-fit')
      }
    })
  }
}
fixObjectFit()

// function isIE () {
//   // var ua = window.navigator.userAgent
//   // var msie = ua.indexOf('MSIE ')
//   // console.log(ua)
//   // if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
//   //   return true
//   // } else {
//   //   return false
//   // }
//   console.log(!!window.MSInputMethodContext && !!document.documentMode)
//   return !!window.MSInputMethodContext && !!document.documentMode
// }
